export default __webpack_public_path__ + "c22648f917e59ff3107741e23a0f32c5.png";